import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/**
 * React Query key for the portal appointments list. Exported so
 * mutation hooks that need to invalidate it (e.g. after booking or
 * cancelling) can reference it directly.
 */
export const appointmentsQueryKey = ['appointments'] as const

/**
 * Loads the signed-in member's upcoming appointments across all of
 * their non-archived patients via `GET /api/portal/appointments`.
 */
export function useListAppointments(options: { enabled?: boolean } = {}) {
  const api = usePortalApi()
  return useQuery({
    queryKey: appointmentsQueryKey,
    enabled: options.enabled ?? true,
    queryFn: async () => dataOrThrow(await api.get('/appointments')),
  })
}
